import { Avatar, Button, Card, FormControl, FormHelperText, FormLabel, Spinner, Textarea, color, Box, Heading, Text, SimpleGrid } from "@chakra-ui/react"
import { NormalUserContainer } from "../../styleComponents/NormalUserStyle"
import { useSelector } from "react-redux"
import AppCreate from "../../sections/AppCreate";
import { useState } from "react";
import Axios from "../../utils/httpClient";
import { useEffect } from "react";
import Moment from "react-moment";
import StatusShow from "../../sections/StatusShow";
import { monthList } from "../../sections/MonthShow";
import { IMG_URL } from "../../utils/api"
import Layout from "../../sections/Layout";
import { useNavigate } from "react-router-dom";

const WelcomePage = () => {
    const {user} = useSelector(s=>s);
    const navigate = useNavigate();
    const [teachers, setTeachers] = useState([]);
    const [loading, setLoading] = useState(false);
    
    useEffect(()=>{
        getTeachersWithOverallPoints()
    }, [])
    
    const getTeachersWithOverallPoints = () => {
        setLoading(true);
        Axios().get('api/v1/application/all-teachers-overall-points/')
        .then(res=>{
            setTeachers(res?.data?.teachers??[])
        }).catch(e=>{
            console.error('Error fetching teachers with overall points:', e);
        }).finally(()=>{
            setLoading(false);
        })
    }
    
    // Calculate statistics for each range
    const rangeStats = {
        '100-70': teachers.filter(teacher => teacher.total_points >= 70 && teacher.total_points <= 100).length,
        '70-50': teachers.filter(teacher => teacher.total_points >= 50 && teacher.total_points < 70).length,
        '50-30': teachers.filter(teacher => teacher.total_points >= 30 && teacher.total_points < 50).length,
        '30-0': teachers.filter(teacher => teacher.total_points >= 0 && teacher.total_points < 30).length
    };
    
    const handleRangeClick = (range) => {
        navigate(`/teachers-with-points-range/${range}`);
    };
    
    const now_date = new Date();
    return(<>
        <Layout showLoginButton={true}>
            <NormalUserContainer>
                {/* Remove the old card with ball count and date */}
                <Card p={6}>
                    <Heading size="md" mb={4} textAlign="center">Baholanganlar</Heading>
                    <SimpleGrid columns={{ base: 1, md: 2, lg: 4 }} spacing={6}>
                        <Card 
                            p={6} 
                            bg="green.100" 
                            _hover={{ bg: "green.200", cursor: "pointer" }}
                            onClick={() => handleRangeClick('100-70')}
                            minH="120px"
                            display="flex"
                            flexDirection="column"
                            justifyContent="center"
                            alignItems="center"
                        >
                            <Text fontWeight={600} fontSize="lg" textAlign="center">100-70</Text>
                            <Text fontSize="2xl" fontWeight={700} textAlign="center">{rangeStats['100-70']}</Text>
                        </Card>
                        <Card 
                            p={6} 
                            bg="blue.100" 
                            _hover={{ bg: "blue.200", cursor: "pointer" }}
                            onClick={() => handleRangeClick('70-50')}
                            minH="120px"
                            display="flex"
                            flexDirection="column"
                            justifyContent="center"
                            alignItems="center"
                        >
                            <Text fontWeight={600} fontSize="lg" textAlign="center">70-50</Text>
                            <Text fontSize="2xl" fontWeight={700} textAlign="center">{rangeStats['70-50']}</Text>
                        </Card>
                        <Card 
                            p={6} 
                            bg="orange.100" 
                            _hover={{ bg: "orange.200", cursor: "pointer" }}
                            onClick={() => handleRangeClick('50-30')}
                            minH="120px"
                            display="flex"
                            flexDirection="column"
                            justifyContent="center"
                            alignItems="center"
                        >
                            <Text fontWeight={600} fontSize="lg" textAlign="center">50-30</Text>
                            <Text fontSize="2xl" fontWeight={700} textAlign="center">{rangeStats['50-30']}</Text>
                        </Card>
                        <Card 
                            p={6} 
                            bg="red.100" 
                            _hover={{ bg: "red.200", cursor: "pointer" }}
                            onClick={() => handleRangeClick('30-0')}
                            minH="120px"
                            display="flex"
                            flexDirection="column"
                            justifyContent="center"
                            alignItems="center"
                        >
                            <Text fontWeight={600} fontSize="lg" textAlign="center">30-0</Text>
                            <Text fontSize="2xl" fontWeight={700} textAlign="center">{rangeStats['30-0']}</Text>
                        </Card>
                    </SimpleGrid>
                </Card>
                <AppCreate getApps={getTeachersWithOverallPoints} fromWelcome={true}/>
                {/* Remove the teachers list section */}
            </NormalUserContainer>
        </Layout>
    </>)
}

export default WelcomePage